export default "__VITE_ASSET__B6YVZxCH__"